"use strict";
// R67 · The year a publication is shown, filtered and sorted by.
//
// An early-access publication has no definitive year: the importer stores
// `fecha_early_access` and leaves `año_publicacion` NULL. The effective year is
// COALESCE(año_publicacion, YEAR(fecha_early_access)) — the paper's real (online) date, never an
// invented one. Null only when both are missing («Sin año»).
Object.defineProperty(exports, "__esModule", { value: true });
exports.anioEfectivoPublicacion = anioEfectivoPublicacion;
function anioEfectivoPublicacion(p) {
    if (p.anoPublicacion != null)
        return { anio: p.anoPublicacion, deEarlyAccess: false };
    const fecha = p.fechaEarlyAccess;
    if (fecha == null)
        return { anio: null, deEarlyAccess: false };
    const d = fecha instanceof Date ? fecha : new Date(fecha);
    const anio = d.getUTCFullYear();
    return Number.isNaN(anio) ? { anio: null, deEarlyAccess: false } : { anio, deEarlyAccess: true };
}
